import React from 'react';

export const MichiganInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Michigan</p>

        <p className="eds-l-mar-bot-1">
            <strong>Debt Funding & Access to Capital Programs</strong> |&nbsp;
            <a
                href="https://www.michiganbusiness.org/press-releases/2020/03/medc-states-small-business-support-organizations-join-forces-to-develop-resources-for-michigans-small-businesses-impacted-by-covid-19/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Michigan Economic Development Corporation (MEDC) ensures economic
            support through debt funding programs and Access to Capital programs
            (aside from SBA assistance).
        </p>

        <p className="eds-l-mar-bot-1 eds-l-mar-top-4">
            <strong>Small Business Relief Program</strong> |&nbsp;
            <a
                href="https://www.michigan.gov/coronavirus/0,9753,7-406-98163-522285--,00.html"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            $10M in grant funding will be provided to local or nonprofit
            economic development organizations throughout the state to provide
            grants up to $10,000 each to support certain small businesses that
            have realized a significant financial hardship as a result of the
            COVID-19 virus.
        </p>
    </div>
);
